/**
 * @Description: 路由配置
 * @Date: 2019-9-25
 * @Modify:
 * @Author: zhangxiaofeng
 */
// const Home = r => require.ensure([], () => r(require('views/budget/home')), 'Home');
/* Layout */
import Layout from '@/components/layout/Index.vue'

export default [
  {
    path: '/upload',
    component: Layout,
    redirect: '/upload/done/project',
    children: [
      {
        path: 'done',
        redirect: '/upload/done/project',
        component: () => import('@/views/upload/Index'),
        children: [
          {
            path: ':type',
            component: () => import('@/views/upload/children/Done'),
            meta: { title: '上传记录', icon: 'home', noCache: true, keepAlive: false, auth: true },
            name: 'UploadHistoryDone'
          }
        ]
      },
      {
        path: 'doing',
        redirect: '/upload/doing/project',
        component: () => import('@/views/upload/Index'),
        children: [
          {
            path: ':type',
            component: () => import('@/views/upload/children/Doing'),
            meta: { title: '上传记录', icon: 'home', noCache: true, keepAlive: false, auth: true },
            name: 'UploadHistoryDoing'
          }
        ]
      }
    ]
  },
  {
    path: '/upload/detail',
    component: () => import('@/views/upload/Detail'),
    meta: { title: '导入详情', icon: 'home', noCache: true, keepAlive: false, auth: true },
    name: 'UploadDetail'
  }
]
